import { textCss } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NavButtonWithPopoutText/NavButtonWithPopoutText.styles";

const NavButtonWithPopoutText = ({ children }: INavButtonWithPopoutText) => {
  return (
    <span css={textCss} data-text={children}>
      {children}
    </span>
  );
};

interface INavButtonWithPopoutText {
  children: string;
}

NavButtonWithPopoutText.displayName = "NavButtonWithPopoutText";
export { NavButtonWithPopoutText };
